import React from 'react';
import ComingSoonPage from './componenets/ComingSoonPage';

export const FuneralServices = () => {
  return <ComingSoonPage title="Funeral services" description="Compassionate funeral-service information for families and community members." image="/images/HomeSlider14.jpg" />;
}
